module.exports = __webpack_public_path__ + "fd099853f51727d3ec259193f1ad9765.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/clowns-cabin.png
// module id = 568
// module chunks = 0